import React, { useEffect, useState } from "react";
import Modal from "sushiweb/Modal";
import styled from "styled-components";

import Table from "../../Common/Table";
import TableSearch from "../TableSearch";
import TableFields from "../../../constants/TripStatistics/TableFields.json";
import { getPath, getReadableDateTime } from "../../../utils";
import BlankState from "../../Common/BlankState";

const TripStatisticsData = (props) => {
  const { data } = props;
  const [list, setList] = useState(data);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  useEffect(() => {
    setList(data);
  }, [data]);

  const viewFileName = (val) => {
    setModalContent(val);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const onTableSearchInput = (val) => {
    if (!val) {
      setList(data);
      return;
    }

    const filteredList = data.filter((item) =>
      JSON.stringify(item).includes(val)
    );
    setList(filteredList);
  };

  const getFieldValue = (obj, key) => {
    switch (key) {
      case "value":
        return (
          <span
            onClick={() => viewFileName(JSON.stringify(obj[key], undefined, 4))}
            className="edit-options cursor-pointer"
          >
            See Value
          </span>
        );
      case "created_at":
      case "updated_at":
        return getReadableDateTime(obj[key]);
      default:
        return obj[key];
    }
  };

  return (
    <>
      {data.length > 0 ? <TableSearch onChange={onTableSearchInput} /> : ""}
      {getPath(list, "length", -1) > 0 ? (
        <>
          <Table
            list={list.sort(
              (obj1, obj2) =>
                new Date(obj2.created_at) - new Date(obj1.created_at)
            )}
            getFieldValue={getFieldValue}
            fields={TableFields}
          />
          {showModal && (
            <Modal
              visible={showModal}
              onClose={handleClose}
              type="medium"
              showCloseIcon={true}
              slideOnMobile
              isCentered
              padding="2rem"
              preventFocus
            >
              <Preformatted style={{ fontSize: "1rem" }} className="medium">
                {modalContent}
              </Preformatted>
            </Modal>
          )}
        </>
      ) : (
        <BlankState />
      )}
    </>
  );
};

const Preformatted = styled.pre`
  overflow: scroll;
`;

export default TripStatisticsData;
